import { Transaction } from 'components/TransactionAllocator';
import { CalendarDay } from 'further-ui/utils';
import { TransactionOperation } from 'further-types/lp/transaction';
import { CurrencyCode } from 'further-types/lp/vehicle';
import { useCapitalActionsTransactions } from './useCapitalActionsTransactions';

type LinkedCapitalActionTransaction = {
  actionId: string;
  name: string;
  ledgerDate: CalendarDay;
  transactionTypeId: string;
  transactionSubType: string;
  operationType: TransactionOperation;
  amountIncVatTcy: number;
  amountExVatTcy: number;
  amountIncVatLcy: number;
  amountExVatLcy: number;
  commitmentId: string;
  label?: string;
  effectiveCapitalDate?: CalendarDay;
};

type UseLinkedCapitalActionsTransactionsProps = {
  linkedCapitalActionsTransactions: Array<LinkedCapitalActionTransaction>;
  baseCurrency: CurrencyCode;
  savedTransactions?: Record<string, Array<Transaction>>;
};

export const useLinkedCapitalActionsTransactions = ({
  linkedCapitalActionsTransactions,
  baseCurrency,
  savedTransactions,
}: UseLinkedCapitalActionsTransactionsProps) => {
  return useCapitalActionsTransactions({
    capitalActionsTransactions: linkedCapitalActionsTransactions,
    baseCurrency,
    savedTransactions,
  });
};
